import React, { useState, useEffect } from 'react';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';

const Toast = ({ message, type = 'info', duration = 5000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const types = {
    success: {
      bg: 'bg-success',
      icon: CheckCircle,
      text: 'text-white'
    },
    error: {
      bg: 'bg-danger',
      icon: AlertCircle,
      text: 'text-white'
    },
    info: {
      bg: 'bg-primary',
      icon: Info,
      text: 'text-white'
    },
    warning: {
      bg: 'bg-warning',
      icon: AlertCircle,
      text: 'text-white'
    }
  };

  const config = types[type];
  const Icon = config.icon;

  return (
    <div
      className={`fixed top-4 right-4 z-50 transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
      }`}
    >
      <div className={`${config.bg} ${config.text} px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 min-w-[300px] max-w-md`}>
        <Icon size={20} />
        <p className="flex-1 text-sm font-medium">{message}</p>
        <button onClick={() => { setIsVisible(false); setTimeout(onClose, 300); }} className="hover:opacity-75">
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

// Hook pour gérer les toasts
export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = 'info') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  const ToastContainer = () => (
    <>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </>
  );

  return { showToast, ToastContainer };
};

export default Toast;
